import { render } from "./BookDataStoreView.vue?vue&type=template&id=5f460ce4&scoped=true"
import script from "./BookDataStoreView.vue?vue&type=script&lang=js"
export * from "./BookDataStoreView.vue?vue&type=script&lang=js"

import "./BookDataStoreView.vue?vue&type=style&index=0&id=5f460ce4&scoped=true&lang=css"

import exportComponent from "E:\\project\\spiderx-gui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f460ce4"]])

export default __exports__